/**
 * Выполняет переход браузера на указанный URL через `location.assign`.
 *
 * @param url Абсолютный или относительный адрес для навигации.
 */
export const navigateTo = (url: string): void => {
	window.location.assign(url);
};
